export const USER_CONTRIBUTION_REQUEST = "USER_CONTRIBUTION_REQUEST";
export const USER_CONTRIBUTION_SUCCESS = "USER_CONTRIBUTION_SUCCESS";
export const USER_CONTRIBUTION_FAIL = "USER_CONTRIBUTION_FAIL";
